import { render, staticRenderFns } from "./InstrumentsDetail.vue?vue&type=template&id=3b3ace70&scoped=true&"
import script from "./InstrumentsDetail.vue?vue&type=script&lang=js&"
export * from "./InstrumentsDetail.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentsDetail.vue?vue&type=style&index=0&id=3b3ace70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ace70",
  null
  
)

export default component.exports